import { useCallback } from 'react';

import { logout } from '@izimi/auth';
import { useAppStore } from 'core/store/appStore';

export const useLogout = () => {
  const { setIsLoggingOut } = useAppStore();

  return useCallback(() => {
    setIsLoggingOut();
    logout();
  }, [setIsLoggingOut]);
};
